import ActivityBuilderInlineSvg from 'approot/shared/inline-svg/activity-builder/activity-builder-inline-svg';
import { ANSWER_LABELS } from './multiple-choice.constants';
import IconPartiallyCorrect from 'approot/shared/inline-svg/activity-builder/icon-partially-correct';
import IconIncorrectDim from 'approot/shared/inline-svg/activity-builder/icon-incorrect-dim';
import IconCorrectDim from 'approot/shared/inline-svg/activity-builder/icon-correct-dim';
import * as Styled from './multiple-choice.style';

export const MultipleChoiceLetter = ({ index }: { index: number }) => (
  <Styled.MultipleChoiceLetter>
    {ANSWER_LABELS[index]}.
  </Styled.MultipleChoiceLetter>
);

export const MultipleChoiceLetterImage = ({ index }: { index: number }) => (
  <Styled.MultipleChoiceImageLetter>
    {ANSWER_LABELS[index]}
  </Styled.MultipleChoiceImageLetter>
);

export const MultipleChoiceStatus = ({
  isCorrect,
  isIncorrect,
  isPartiallyCorrect,
  isRevealAnswer,
}: {
  isCorrect?: boolean;
  isIncorrect?: boolean;
  isPartiallyCorrect?: boolean;
  isRevealAnswer: boolean;
}) => (
  <>
    {!isPartiallyCorrect && isCorrect && (
      <Styled.MultiChoiceCorrectIcon data-selector="revealed-answer-true">
        {isRevealAnswer ? (
          <IconCorrectDim width={36} height={36} />
        ) : (
          <ActivityBuilderInlineSvg id="icon_correct" width={36} height={36} />
        )}
      </Styled.MultiChoiceCorrectIcon>
    )}
    {!isPartiallyCorrect && isIncorrect && (
      <Styled.MultiChoiceCorrectIcon data-selector="revealed-answer-false">
        {isRevealAnswer ? (
          <IconIncorrectDim width={36} height={36} />
        ) : (
          <ActivityBuilderInlineSvg
            id="icon_incorrect"
            width={36}
            height={36}
          />
        )}
      </Styled.MultiChoiceCorrectIcon>
    )}
    {isPartiallyCorrect && !isRevealAnswer && (
      <Styled.MultiChoiceCorrectIcon data-selector="revealed-answer-partial">
        <IconPartiallyCorrect width={36} height={36} />
      </Styled.MultiChoiceCorrectIcon>
    )}
  </>
);

export const MultipleChoiceListCorrect = ({
  isRevealAnswer,
}: {
  isRevealAnswer: boolean;
}) => (
  <Styled.MultiChoiceListCorrectIcon>
    {isRevealAnswer ? (
      <IconCorrectDim width={24} height={24} />
    ) : (
      <ActivityBuilderInlineSvg id="icon_correct" width={24} height={24} />
    )}
  </Styled.MultiChoiceListCorrectIcon>
);

export const MultipleChoiceListIncorrect = ({
  isRevealAnswer,
}: {
  isRevealAnswer: boolean;
}) => (
  <Styled.MultiChoiceListCorrectIcon>
    {isRevealAnswer ? (
      <IconIncorrectDim width={24} height={24} />
    ) : (
      <ActivityBuilderInlineSvg id="icon_incorrect" width={24} height={24} />
    )}
  </Styled.MultiChoiceListCorrectIcon>
);

export const MultipleChoiceListPartiallyCorrect = () => (
  <Styled.MultiChoiceListCorrectIcon>
    <IconPartiallyCorrect width={24} height={24} />
  </Styled.MultiChoiceListCorrectIcon>
);
